import React from "react";

// BAWAIN mark: location pin + shopping bag + travel arrow
export function LogoMark({ size = 32, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className} data-testid="logo-mark">
      <path
        d="M24 3C15.7 3 9 9.6 9 17.8 9 28.5 24 45 24 45s15-16.5 15-27.2C39 9.6 32.3 3 24 3Z"
        fill="#102A43"
      />
      <path d="M18 16h12l-1.2 12.2a2 2 0 0 1-2 1.8h-5.6a2 2 0 0 1-2-1.8L18 16Z" fill="#B7E33A" />
      <path d="M20.5 16v-1.5a3.5 3.5 0 1 1 7 0V16" stroke="#102A43" strokeWidth="2" strokeLinecap="round" fill="none" />
      <path d="M21 22.5h6M24 19.5l3 3-3 3" stroke="#102A43" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none" />
    </svg>
  );
}

export function Logo({ size = 32, showText = true, light = false }) {
  return (
    <div className="flex items-center gap-2 select-none">
      <LogoMark size={size} />
      {showText && (
        <span className={`font-heading font-extrabold tracking-tight text-xl ${light ? "text-white" : "text-navy"}`}>
          BAWAIN
        </span>
      )}
    </div>
  );
}
